import React from 'react';
import { useSelector } from 'react-redux';
import getSpacesPager from '@src/containers/SpacesListing/selectors/getSpacesPager';
import PagingCDefault from './default';

const PagingCSpaces = () => {
	const pager = useSelector(getSpacesPager);
	return (
		<PagingCDefault
			isShallow
			totalPages={pager.totalPages}
			totalQtty={pager.totalCount}
		/>
	);
};

export default PagingCSpaces;
